import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import {
  ACTION_BACK_PATH,
  SCHOOL_HEALTH_ASSESSMENT_SUMMARY_DETAILS_PATH,
  SCHOOL_HEALTH_ASSESSMENT_SUMMARY_PATH,
} from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';

const SchoolHealthAssessmentSummaryPage = lazy(
  () => import('./pages/SchoolHealthAssessmentSummaryPage/SchoolHealthAssessmentSummaryPage')
);
const SchoolHealthAssessmentSummaryDetailsPage = lazy(
  () => import('./pages/SchoolHealthAssessmentSummaryDetailsPage/SchoolHealthAssessmentSummaryDetailsPage')
);

export const SCHOOL_HEALTH_ASSESSMENT_ROUTES = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SchoolHealthAssessmentSummaryPage />,
    displayTitle: () => 'School Health Plan',
    pageType: PageType.PRIVATE,
    path: SCHOOL_HEALTH_ASSESSMENT_SUMMARY_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.schoolHealthPlan,
  },
  {
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE],
    component: () => <SchoolHealthAssessmentSummaryDetailsPage />,
    displayTitle: () => 'School Health Plan Details',
    pageType: PageType.PRIVATE,
    path: SCHOOL_HEALTH_ASSESSMENT_SUMMARY_DETAILS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.schoolHealthPlan,
  },
];
